<template>
  <div
    v-if="$store.state.logsView"
    class="log-view"
  >
    <div class="close"
        @click="clickHandle"
    >X</div>
    <ul>
        <li v-for="(log, index) in logs" :key="index" class="log-entry">
            {{ log }}
        </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      debugClickCount: 0,
      debugClickTimer: null
    }
  },
  computed: {
    logs() {
      return this.$store.state.logs
    }
  },
  methods: {
    clickHandle() {
      this.$store.commit('SET_LOGS_VIEW', false)
    }
  }
}
</script>

<style scoped>
.log-view {
  position: fixed;
  top: 4rem;
  left: 4rem;
  width: 90dvw;
  height: 50dvh;
  overflow-y: scroll;
  background-color: #00000096;
  color: #ffffff;
  padding: 10px;
  padding-top: 20px;
}
.log-entry{
    white-space: pre-wrap;
    word-break: break-word;
}
.close{
    position: absolute;
    top: 1rem;
    right: 1rem;
}
</style>
